import { render, staticRenderFns } from "./TimelineExchange.vue?vue&type=template&id=164b0efe&scoped=true"
import script from "./TimelineExchange.vue?vue&type=script&lang=js"
export * from "./TimelineExchange.vue?vue&type=script&lang=js"
import style0 from "./TimelineExchange.vue?vue&type=style&index=0&id=164b0efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b0efe",
  null
  
)

export default component.exports